import React from 'react';
import Coin from '../Coin';

interface EffectPriceProps {
  originalPrice: number;
  effectivePrice?: number;
}

/**
 * Displays a shop item price, showing the effective (discounted) price
 * alongside the struck-through original when an effect is active.
 */
const EffectPrice: React.FC<EffectPriceProps> = ({
  originalPrice,
  effectivePrice,
}) => {
  if (effectivePrice == null || effectivePrice === originalPrice) {
    return <Coin>{originalPrice}</Coin>;
  }

  return (
    <span className="d-inline-flex align-items-center gap-2">
      <span className="text-decoration-line-through text-muted small">
        {originalPrice}
      </span>
      <Coin>{effectivePrice}</Coin>
    </span>
  );
};

export default EffectPrice;
export type { EffectPriceProps };
